import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { PraticheTabsComponent } from '../../pratiche/pratiche-tabs/pratiche-tabs.component';

import { AvanzaPraticheService } from '../../../services/avanza-pratiche.service';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-pratica-view',
  templateUrl: './pratica-view.component.html',
  styleUrls: ['./pratica-view.component.css']
})
export class PraticaViewComponent extends AppComponentGenericComponent implements OnInit {
    @Input() data: string = '';
    @Input() writePermission: boolean = false;
    @Output() innerEvents = new EventEmitter();

    pratica: any[] = [];

    constructor(private avanzaPraticheService: AvanzaPraticheService, protected dataService: DataService) {
	super(dataService, 'pratica-view');
    }

    ngOnInit() {
    }

    ngOnChanges(changes: any){
	console.log('CHANGE PRATICA-VIEW', this.data);
	if(changes.data) {
	    console.log('CHANGE PRATICA-VIEW', this.data);
	    this.pratica = this.data['pratica'];
	}
    }

    openNewRate(eventRate) {
	console.log("eventRate", eventRate);
	this.dataService.openNewRate(eventRate);
	let event = {
	    openNewRate: true,
	    modalType: 'avanza-pratiche',
	};
	this.innerEvents.emit(event);
        //mw.show('avanza-pratiche');
    }
}
